import { defineStore } from 'pinia';
import EleveInscriptionAjax from '@/services/EleveInscriptionAjax';
import useAppStore from '@/store/appStore';
import i18n from '@/i18n';

export default defineStore('panierStore', {
  state: () => ({
    chargement: false,
    chargementPasserCaisse: false,

    listeCoursPanier: [],
    listeDocumentsPanier: [],

    panier: null,
    documentPanier: [],
  }),
  getters: {},
  actions: {
    async rafraichirPanier() {
      try {
        this.chargement = true;
        this.listeCoursPanier = await EleveInscriptionAjax.rafraichirPanier(this.listeCoursPanier);
      } catch (e) {
        useAppStore().erreur = e;
      } finally {
        this.chargement = false;
      }
    },
    async definirListeCoursPanier(listeCours) {
      try {
        this.chargement = true;
        // Si listeCours contient somehow des null, '' ou undefined les retirer avant de procéder
        listeCours = listeCours.filter((x) => x);

        this.listeCoursPanier = listeCours;
        this.listeDocumentsPanier = await EleveInscriptionAjax.obtenirDocumentsPanier(listeCours);
      } catch (e) {
        useAppStore().erreur = e;
      } finally {
        this.chargement = false;
      }
    },

    async envoyerFichier(idEleveEcole, typeDocument, fichier, typeDocumentEnum = false) {
      try {
        this.chargement = true;
        const fichiers = await EleveInscriptionAjax.envoyerFichier(idEleveEcole, typeDocument, fichier, typeDocumentEnum);

        if (fichiers != null) {
          this.documentPanier.push(fichiers);
        }
      } catch (e) {
        useAppStore().erreur = e;
      } finally {
        this.chargement = false;
      }
    },
    async acheterPanier(identificationEleve) {
      try {
        this.chargement = true;
        const panier = await EleveInscriptionAjax.acheterPanier(identificationEleve);

        if (panier == null) {
          throw new Error(i18n.t('erreurs.uneErreurEstSurvenue'));
        } else {
          this.panier = panier;
        }
      } catch (e) {
        useAppStore().erreur = e;
      } finally {
        this.chargement = false;
      }
    },
  },
});
